<div class="upload-files-box"
    [ngClass]="{'animate': (uploadStatus$ | async) === 'Starting' || (updateAndResumeUploadLoading$ | async)}"
    *ngIf="files">
    <app-smash-file-drop class="file-drop" (fileDrop)="dropped($event)" dropDisabled="true" [directory]="isDirectory">
        <ng-template let-openFileSelector="openFileSelector">
            <div class="upload-files-box-header" [ngClass]="{'no-border': errorsDetected}">
                <div class="left-header">
                    <span class="left-header-text-total-count" translate
                        [translateParams]="{ count : files.length }">UPLOADER_FILES_COUNT</span>
                    <span class="left-header-text-total-size" *ngIf="totalToUpload">({{ totalToUpload |
                        bytes:2}})</span>
                </div>
                <div class="right-header" (clickOutside)="closeDropdownAddFiles()">
                    <ng-container *ngIf="isSafari; else notSafari">
                        <app-smash-file-drop class="add-files-dropdown-item-container" (fileDrop)="dropped($event)"
                            dropDisabled="true" directory="true">
                            <ng-template let-openFileSelector="openFileSelector">
                                <div class="upload-files-box-add-button" (click)="openFileSelector($event)">
                                    <span>+</span>
                                </div>
                            </ng-template>
                        </app-smash-file-drop>
                    </ng-container>
                    <ng-template #notSafari>
                        <div class="upload-files-box-add-button" (click)="toggleDropdownAddFiles()">
                            <span>+</span>
                        </div>
                        <div class="add-files-dropdown" *ngIf="addFilesDropdownToggled">
                            <div class="add-files-dropdown-item" (click)="openSelectFiles('files')">
                                <span class="add-files-dropdown-item-plus">+</span>
                                <div class="add-files-dropdown-item-text" translate>UPLOADER_OPTION_FILES</div>
                            </div>
                            <div class="separator"></div>
                            <div class="add-files-dropdown-item" (click)="openSelectFiles('folder')">
                                <span class="add-files-dropdown-item-plus">+</span>
                                <div class="add-files-dropdown-item-text" translate>UPLOADER_OPTION_DIRECTORY
                                </div>
                            </div>
                        </div>
                    </ng-template>

                </div>
            </div>
            <div>
                <div class="file-import-container-error" *ngIf="fileDescriptions?.length && errorsDetected" translate>
                    <ng-container [ngSwitch]="fileDescriptions[0]?.errors[0]">
                        <span *ngSwitchCase="'NotFoundError'"
                            translate>UPLOADER_ERROR_READING_FILE_DETAILS_FILE_NOT_FOUND_ERROR</span>
                        <span *ngSwitchCase="'SecurityError'"
                            translate>UPLOADER_ERROR_READING_FILE_DETAILS_SECURITY_ERROR</span>
                        <span *ngSwitchCase="'NotReadableError'"
                            translate>UPLOADER_ERROR_READING_FILE_DETAILS_NOT_READABLE_ERROR</span>
                    </ng-container>
                </div>
                <div class="files-list-container" *ngIf="fileDescriptions?.length">
                    <ul class="files-list">
                        <ng-scrollbar class="scroll-files"  externalViewport>
                            <cdk-virtual-scroll-viewport scrollViewport 
                        itemSize="49"
                        class="virtual-scroll-height">
                                <li *cdkVirtualFor="let file of fileDescriptions" class="files-list-item">
                                    <ng-container *ngIf="file.type === 'Folder'; else isFile">
                                        <div class="meta-container">
                                            <div class="title">
                                                <i class="title-icon icon-smash_folder"></i>
                                                <span class="title-name" [tooltip]="fileNameTooltipTemplate"
                                                    content-type="template" [options]="tooltipFileOptions"
                                                    theme="light">{{file.name}}</span>
                                            </div>
                                            <ng-template #fileNameTooltipTemplate>
                                                <div class="tooltip-content">
                                                    {{file.name}}
                                                </div>
                                            </ng-template>
                                            <div class="description">
                                                <ng-container *ngIf="file?.errors?.length > 0; else noError">
                                                    <span class="error-import"
                                                        translate>UPLOADER_FILES_IMPORT_ERROR</span>
                                                </ng-container>
                                                <ng-template #noError>
                                                    <span class="file-number" *ngIf="file.fileNumber" translate
                                                        [translateParams]="{ count: file.fileNumber}">UPLOADER_FILES_COUNT</span>
                                                    <span class="separator">-</span>
                                                    <span class="size" *ngIf="file.size">{{file.size | bytes: 2}}</span>
                                                </ng-template>
                                            </div>
                                        </div>
                                    </ng-container>
                                    <ng-template #isFile>
                                        <div class="meta-container">
                                            <div class="title">
                                                <i class="title-icon icon-smash_file"></i>
                                                <span class="title-name" [tooltip]="fileNameTooltipTemplate"
                                                    content-type="template" [options]="tooltipFileOptions"
                                                    theme="light">{{file.name}}</span>
                                                <ng-template #fileNameTooltipTemplate>
                                                    <div class="tooltip-content">
                                                        {{file.name}}
                                                    </div>
                                                </ng-template>
                                            </div>
                                            <div class="description">
                                                <ng-container *ngIf="file?.errors?.length > 0; else noError">
                                                    <span class="error-import"
                                                        translate>UPLOADER_FILES_IMPORT_ERROR</span>
                                                </ng-container>
                                                <ng-template #noError>
                                                    <span class="size" *ngIf="file.size">{{file.size | bytes: 2}}</span>
                                                    <span class="separator">-</span>
                                                    <span class="extension">.{{file.extension}}</span>
                                                </ng-template>
                                            </div>
                                        </div>
                                    </ng-template>
                                    <span (click)="onRemoveFile(file)" class="files-list-item-icon-delete icon-smash_close"></span>
                                </li>
                            </cdk-virtual-scroll-viewport >
                        </ng-scrollbar>
                    </ul>
                </div>
            </div>
        </ng-template>
    </app-smash-file-drop>
</div>